import { HostServices } from '@ally/federated-types'

type TransmitRef = HostServices['transmitRef']
type SessionData = HostServices['session']['data']

export async function getTransferTicket(
  transmit: TransmitRef,
  sessionData: SessionData,
): Promise<string> {
  if (!sessionData) throw new Error('Session Data Missing')

  const result = await transmit.transferTicket({
    destination: 'auto',
    access_token: sessionData.access_token,
    username: sessionData.userNamePvtEncrypt,
    journey_version: 'v2',
  })

  if (result?.type !== 'ticket') throw new Error('Transfer Ticket Error')

  return result.ticketID
}
